<template>
    <b-table :fields="fields" :items="aepModelList" class="aep-view-table" />
</template>

<script>
import Consts from '@/store/models/consts/clientConsts' 
export default {
    props: {
        aepModelList: {
            type: Array,
            default: () => []
        }        
    },
    data: function() {
        return {
            fields: [
                { key: 'Name', label: 'Название' },
                {
                    key: 'Type',
                    label: 'Категория',
                    formatter: value => {
                        return Consts.CategoryAep.find(e => e.Id == value).Text;
                    }
                }
            ]
        }
    }
}
</script>

<style>
.aep-view-table.table thead th {
    color: #5b5959;
    font-family: "HelveticaNeueCyr-Medium";
    font-weight: normal;
    font-size: 18px;
}
</style>